import { Box } from "ui/box";
import { Skeleton } from "ui/skeleton";

import {
  SKELETON_BAR_SX,
  SKELETON_GROUP_SX,
  SKELETON_SECTION_SX,
  SKELETON_SX,
} from "containers/admin/clients/client/theme-configuration-page/theme-preview/theme-preview.styles";

type Bar = { height: number; width?: string };

const PARAGRAPH: Bar[] = [{ height: 12 }, { height: 12 }, { height: 12, width: "74.5%" }];

const SECTIONS: Bar[][][] = [
  [
    [{ height: 120 }, { height: 24 }, { height: 24, width: "61.25%" }],
    [{ height: 16 }, { height: 16 }],
  ],
  [PARAGRAPH, PARAGRAPH, [{ height: 44, width: "50.5%" }]],
];

export const PreviewSkeleton = () => (
  <Box role="status" aria-label="Loading preview" sx={SKELETON_SX}>
    {SECTIONS.map((groups, sectionIndex) => (
      <Box key={sectionIndex} sx={SKELETON_SECTION_SX}>
        {groups.map((bars, groupIndex) => (
          <Box key={groupIndex} sx={SKELETON_GROUP_SX}>
            {bars.map(({ height, width = "100%" }, barIndex) => (
              <Skeleton
                key={barIndex}
                variant="rounded"
                height={height}
                width={width}
                sx={SKELETON_BAR_SX}
              />
            ))}
          </Box>
        ))}
      </Box>
    ))}
  </Box>
);
